import React from 'react';

import SdkComponent from './SdkComponent';

export const Label = props => <SdkComponent renderer={'label'} {...props} />;
export const FieldDescription = props => <SdkComponent renderer={'fieldDescription'} {...props} />;
export const DropDown = props => <SdkComponent renderer={"dropdown"} {...props}/>
export const DropdownNative = props => <SdkComponent renderer={"dropdownNative"} {...props}/>
